module.exports = __webpack_public_path__ + "components/flag/static/square/sr-4435b4cf951c3f71f7cf8556af288177.svg";